import 'babel-polyfill' // ie兼容 es6
import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import ElementUI from "element-ui";
import "lib-flexible/flexible";
import "element-ui/lib/theme-chalk/index.css";
import "@/styles/index.css";
import "@/styles/icon/index.css";

import promise from 'es6-promise';
promise.polyfill() // ie兼容 Promise
import 'ie-placeholder'; // ie兼容css placeholder属性


Vue.use(ElementUI);

new Vue({
  router,
  data:{
    Hub: new Vue()
  },
  render: (h) => h(App),
}).$mount("#app");
